export enum FilesModule {
  drive = "drive",
  attachment = "attachment",
}
